import React from 'react';
import { Question } from 'models/Questionnaire';
import { QuestionSlider } from './QuestionSlider';
import Separator from './Separator';
import { ValueResource } from 'models/QuestionnaireResource';
import starred from 'images/starred.png';
import unstarred from 'images/unstarred.png';

export const PrintAnswerSectionField = (props: { answers: Question[], title: string }) => {

	return (
		<React.Fragment>
			<div className='print-answer-title-container'>
				<h3 className='print-answer-category-title'>{props.title}</h3>
				<Separator />
			</div>
			{
				props.answers.map((question, index, arr) => {
					const last = index === arr.length - 1;
					return <div key={`answer${question.id}`} className='print-answer-itself'>
						<div className='print-answer' key={`question${question.id}`}>
							<div className='print-question-text'>
								<p>{question.title}</p>
							</div>
							<QuestionSlider currentValue={question.answer?.primary}
								answerValue={question.category.values?.primary as ValueResource}
								disabled={true}
								title={question.category.questiontitle}
								idPrefix={`print_${question.id}`} />
						</div>
						{
							!last &&
							<Separator className='print-answer-separator' />
						}
					</div>
				})
			}
		</React.Fragment >
	)
}